import { If } from "components";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  getColorsOptionsWithDisabling,
  getSizesOptionsWithDisabling
} from "../../../../helpers";
import { AttributeBlock } from "../../../AttributeBlock";
import { AttributeField } from "../../../AttributeField";
import { GeneralAttributesProps } from "../SubChildCategoryForm.types";

const GeneralAttributes = ({
  control,
  attributes,
  isMaxMainFilters
}: GeneralAttributesProps) => {
  const { t } = useTranslation();

  return (
    <>
      {attributes.map((attribute, attributeIndex) => {
        const isColorAttribute = attribute.name === "Color";
        const isSizeAttribute = attribute.name === "Size";

        return (
          <If
            key={attribute.attributeId}
            condition={isColorAttribute || isSizeAttribute}
          >
            <AttributeBlock>
              <Controller
                control={control}
                name={`attributes.${attributeIndex}`}
                render={({
                  field: { value, onChange },
                  fieldState: { error }
                }) => {
                  const isInputDisabled =
                    isSizeAttribute &&
                    value.values.some(
                      (sizeValue) =>
                        sizeValue.value === "NO SIZES" && !sizeValue.delete
                    );

                  return (
                    <AttributeField
                      placeholder={t("Add custom sizes (enter to apply)")}
                      variant={isSizeAttribute ? "secondary" : "default"}
                      disabledMainFilter={isMaxMainFilters}
                      value={value}
                      onChange={onChange}
                      errorMessage={error}
                      disabledInput={isInputDisabled}
                      options={
                        isSizeAttribute
                          ? getSizesOptionsWithDisabling(value.values)
                          : getColorsOptionsWithDisabling(value.values)
                      }
                    />
                  );
                }}
              />
            </AttributeBlock>
          </If>
        );
      })}
    </>
  );
};

export default GeneralAttributes;
